
define('text!templates/bin_group_name.html',[],function () { return '<span class="group-c">{{bin_group_name}}</span>';});

